import { __exports as config } from "../../../../../../_virtual/config2.js";
import { __require as requireSrc } from "../index.js";
import { __require as requireConfig$1 } from "../types/config.js";
import { __require as requireLoglevel } from "../types/loglevel.js";
var hasRequiredConfig;
function requireConfig() {
  if (hasRequiredConfig) return config;
  hasRequiredConfig = 1;
  Object.defineProperty(config, "__esModule", { value: true });
  config.populateLocalConfigDefaults = config.populateRemoteConfigDefaults = void 0;
  const __1 = requireSrc();
  const config_1 = requireConfig$1();
  const loglevel_1 = requireLoglevel();
  const populateRemoteConfigDefaults = (customConfig) => {
    const config2 = Object.assign(Object.assign({}, __1.RemoteEvaluationDefaults), customConfig);
    config2.logLevel = config2.debug ? loglevel_1.LogLevel.Debug : config2.logLevel;
    const isEu = config2.serverZone.toLowerCase() === config_1.EU_SERVER_URLS.name;
    config2.serverZone = isEu ? "eu" : "us";
    if (!(customConfig === null || customConfig === void 0 ? void 0 : customConfig.serverUrl)) {
      config2.serverUrl = isEu ? config_1.EU_SERVER_URLS.remote : __1.RemoteEvaluationDefaults.serverUrl;
    }
    return config2;
  };
  config.populateRemoteConfigDefaults = populateRemoteConfigDefaults;
  const populateLocalConfigDefaults = (customConfig) => {
    const config2 = Object.assign(Object.assign({}, config_1.LocalEvaluationDefaults), customConfig);
    config2.logLevel = config2.debug ? loglevel_1.LogLevel.Debug : config2.logLevel;
    const isEu = config2.serverZone.toLowerCase() === config_1.EU_SERVER_URLS.name;
    config2.serverZone = isEu ? "eu" : "us";
    if (!(customConfig === null || customConfig === void 0 ? void 0 : customConfig.serverUrl)) {
      config2.serverUrl = isEu ? config_1.EU_SERVER_URLS.flags : config_1.LocalEvaluationDefaults.serverUrl;
    }
    if (!(customConfig === null || customConfig === void 0 ? void 0 : customConfig.streamServerUrl)) {
      config2.streamServerUrl = isEu ? config_1.EU_SERVER_URLS.stream : config_1.LocalEvaluationDefaults.streamServerUrl;
    }
    if ((customConfig === null || customConfig === void 0 ? void 0 : customConfig.cohortSyncConfig) && !(customConfig === null || customConfig === void 0 ? void 0 : customConfig.cohortSyncConfig.cohortServerUrl)) {
      config2.cohortSyncConfig.cohortServerUrl = isEu ? config_1.EU_SERVER_URLS.cohort : config_1.CohortSyncConfigDefaults.cohortServerUrl;
    }
    return config2;
  };
  config.populateLocalConfigDefaults = populateLocalConfigDefaults;
  return config;
}
export {
  requireConfig as __require
};
//# sourceMappingURL=config.js.map
